import React from 'react';
import { buildPrescriptionText } from '../../utils/emrHelpers';
import { MED_INSTRUCTION_SAMPLES } from '../../config/emrSettings';
import { useAuth } from '../../auth/AuthContext';
import { printPrescription, formatHospitalAddress, hospitalName } from '../../utils/hospitalPdf';

export default function EmrPrintPrescription({ form, doctor, hospital, emrSettings, onClose }) {
  const { user } = useAuth();
  const rx = buildPrescriptionText(form.rxLines);
  const date = new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' });
  const name = hospitalName(hospital);
  const addr = formatHospitalAddress(hospital);

  const print = () => printPrescription(form, doctor, hospital, user, emrSettings);

  return (
    <div className="emr-modal-backdrop" onClick={onClose} role="presentation">
      <div className="emr-modal card emr-print-preview" onClick={(e) => e.stopPropagation()}>
        <header className="emr-modal-header">
          <h3>Print prescription</h3>
          <div className="row-actions">
            <button type="button" className="btn btn-primary btn-sm" onClick={print}>Print / PDF</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Close</button>
          </div>
        </header>
        <div className="emr-print-body">
          <p><strong>{name}</strong></p>
          {addr && <p className="hint" style={{ whiteSpace: 'pre-line' }}>{addr}</p>}
          <p className="hint">{date}</p>
          <p><strong>{form.patientName}</strong></p>
          <pre className="rx-pre">{rx || 'No medicines added.'}</pre>
        </div>
      </div>
    </div>
  );
}
